module.exports = __webpack_public_path__ + "static/media/spinner.930a8d1c.svg";